import * as Sentry from '@sentry/react';

import '@/common/firebase';
import '@/common/index.css';
import React from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';

import packageJson from '../../package.json';

Sentry.init({
  dsn: 'https://194583911c69b44c427e9179246fa138@o4508439708434432.ingest.us.sentry.io/4508439708631040',
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [
    'localhost',
    /^https:\/\/tp\.games/,
    /^https:\/\/dev.tp\.games/,
    /^https:\/\/tp-games\.pages\.dev/,
    /^https:\/\/[a-z0-9-]+\.tp-games\.pages\.dev/,
  ],
  environment: import.meta.env.MODE,

  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  release: `${packageJson.name}@${packageJson.version}`,
});

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('No root element found');

// ! Currently not working - this is to prevent swipe to navigate gesture to go back a page on iOS but with this, it stops all* interactions with the page
// rootElement.addEventListener('touchstart', (e) => {
//   // prevent swipe to navigate gesture
//   e.preventDefault();
// });

const root = createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
